import { arrayOf, oneOfType, shape, string } from "prop-types";

/** @deprecated use TypeScript interface or type instead */
export const dynamicFieldType = shape({
  name: string,
  label: shape({
    id: string,
    fallback: string,
  }),
  type: string,
  value: oneOfType([string, arrayOf(string)]),
  url: string,
});
